import types from '../../../mutation-types';
import MessageApi from '../../../../api/inbox/message';

const mergeTranslationIntoMessage = (message, targetLanguage, translatedContent) => {
  const contentAttributes = message.content_attributes || {};
  const existingTranslations = contentAttributes.translations || {};

  return {
    ...message,
    content_attributes: {
      ...contentAttributes,
      translations: {
        ...existingTranslations,
        [targetLanguage]: translatedContent,
      },
    },
  };
};

export default {
  async translateMessage(
    { commit, getters },
    { conversationId, messageId, targetLanguage }
  ) {
    const selectedChat = getters.getSelectedChat;
    const message = selectedChat?.messages?.find(
      chatMessage => chatMessage.id === messageId
    );

    const { data } = await MessageApi.translateMessage(
      conversationId,
      messageId,
      targetLanguage
    );

    if (message && data?.content) {
      commit(
        types.ADD_MESSAGE,
        mergeTranslationIntoMessage(message, targetLanguage, data.content)
      );
    }

    return data;
  },
};
